import { ValidationErrors } from '@angular/forms';

import { CouponFormMessages } from 'appAssets/descriptors/panel-coupons.descriptor';
import { BaseControl } from 'appShared/classes';

/**
 * The shared form messages interpolate one `controlLength` per message, which the caller has to
 * supply — omitting it renders "must be maximum undefined".
 *
 * Every length/bound validator in play already reports its limit in the error payload
 * (`AmountMinValidator`/`AmountMaxValidator` as `min`/`max`, Angular's length validators as
 * `requiredLength`), so the number is read back from there instead of being restated per control.
 */
export const CouponValidationErrorLength = (error: any): number => {
    if (!error || typeof error !== 'object') {
        return undefined;
    }

    return error.max ?? error.min ?? error.requiredLength;
};

/** Resolves one message per failed validator on a control. */
export const CouponControlErrorMessages = (
    control: BaseControl,
    errors: ValidationErrors,
    messagesFunction: (controlLabel?: string, controlLength?: number) => { [key: string]: string }
): string[] => Object.keys(errors).map((key: string) => {
    const messages = {
        ...messagesFunction(control.placeholder, CouponValidationErrorLength(errors[key])),
        ...CouponFormMessages(control.placeholder)
    };

    return messages[key];
});
